import './jquery.slimscroll'
import './sticky-kit.min'
import './sidebarmenu'
import './app'
import './waves'
import './fullscreen'